export default {
  AcceptSnack: 'AcceptSnack',
  BlockSnack: 'BlockSnack',
};
